import { State } from "@features/base/types";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  AdminOrder,
  AdminOrdersRequest,
  AdminOrdersResponse,
  getAdminOrdersApi,
} from "./api";

export const getAdminOrders = createAsyncThunk<
  AdminOrdersResponse,
  { data?: AdminOrdersRequest }
>("adminOrders/getAdminOrders", async ({ data }, { rejectWithValue }) => {
  try {
    return await getAdminOrdersApi(data);
  } catch (error) {
    return rejectWithValue(error);
  }
});

type AdminOrdersState = State<{
  orders: AdminOrder[] | null;
  count: number;
}>;

const initialState: AdminOrdersState = {
  orders: null,
  count: 0,
  loading: false,
  error: null,
};

const adminOrdersSlice = createSlice({
  name: "adminOrders",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminOrders.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload.orders;
        state.count = action.payload.count;
      })
      .addCase(getAdminOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default adminOrdersSlice.reducer;
